import React__default, { createElement, Component } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import { map } from 'd3-collection';
import shareActionFactory from '@ta-interaktiv/share-url-factory';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var DisplayTypes;
(function (DisplayTypes) {
    DisplayTypes["HORIZONTAL_ICONS"] = "horizontal icons";
    DisplayTypes["VERTICAL_BUTTONS"] = "vertical buttons";
    DisplayTypes["HORIZONTAL_BUTTONS"] = "horizontal buttons";
})(DisplayTypes || (DisplayTypes = {}));

var socialNetworkNameReplacement = {
    facebook: 'facebook',
    twitter: 'twitter',
    whatsapp: 'whatsapp',
    share: 'mail'
};

var minimumShares = 30;
function shareCountFormatter(count) {
    return count >= minimumShares ? count : '';
}
function ShareItem(_a) {
    var displayType = _a.displayType, _b = _a.inverted, inverted = _b === void 0 ? false : _b, type = _a.type, count = _a.count, description = _a.description, shareUrl = _a.shareUrl, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var itemClass = type + " " + (inverted ? 'inverted' : '') + " " + className + " share";
    var innerText;
    switch (displayType) {
        case DisplayTypes.HORIZONTAL_ICONS:
            itemClass = itemClass + " item";
            innerText = shareCountFormatter(count);
            break;
        case DisplayTypes.VERTICAL_BUTTONS:
            itemClass = className + " " + (inverted ? 'inverted' : '') + " ui button share";
            innerText = description;
            break;
        case DisplayTypes.HORIZONTAL_BUTTONS:
            itemClass = socialNetworkNameReplacement[type] + " " + className + " ui icon button share";
            innerText = shareCountFormatter(count);
            break;
    }
    return (createElement("a", { href: shareUrl, title: description, className: itemClass, onClick: onClick, target: '_top' },
        createElement("i", { className: socialNetworkNameReplacement[type] + " icon" }),
        innerText));
}

var supportedCommunities = ['twitter', 'facebook', 'whatsapp', 'share'];

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".inverted .ta.sharing:not(.inverted) .share,\n.inverted .ta.sharing .share:not(.inverted) {\n  color: #007abf; }\n";
styleInject(css);

function cleanUrl(url) {
    var loc = new URL(url);
    return "" + loc.origin + loc.pathname;
}
function getDefaultUrl() {
    return cleanUrl(window.location.href);
}

var data = { twitter:{ name:"Twitter",
    description:"Bei Twitter veröffentlichen",
    via:"tagesanzeiger" },
  facebook:{ name:"Facebook",
    description:"Auf Facebook teilen",
    facebook_id:"147124108642216" },
  whatsapp:{ name:"WhatsApp",
    description:"Über WhatsApp texten" },
  share:{ name:"Senden",
    description:"Per Mail senden" } };

var data$1 = { twitter:{ name:"Twitter",
    description:"Publier sur Twitter",
    via:"24heuresch" },
  facebook:{ name:"Facebook",
    description:"Partager sur Facebook",
    facebook_id:"251285271592561" },
  whatsapp:{ name:"WhatsApp",
    description:"Publier les textes sur WhatsApp" },
  share:{ name:"Envoyer",
    description:"Envoyer par email" } };

var allMessages = {
    de: data,
    fr: data$1
};
function ShareButtons(_a) {
    var _b = _a.displayType, displayType = _b === void 0 ? DisplayTypes.VERTICAL_BUTTONS : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c, communities = _a.communities, hashtags = _a.hashtags, _d = _a.url, url = _d === void 0 ? getDefaultUrl() : _d, _e = _a.clickHandler, clickHandler = _e === void 0 ? function () { } : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.itemClassName, itemClassName = _g === void 0 ? '' : _g, _h = _a.additionalFacebookShares, additionalFacebookShares = _h === void 0 ? 0 : _h, _j = _a.locale, locale = _j === void 0 ? 'de' : _j;
    var messages = allMessages[locale];
    var groupClass = "ta sharing ui " + className;
    switch (displayType) {
        case DisplayTypes.HORIZONTAL_ICONS:
            groupClass += ' horizontal link list';
            break;
        case DisplayTypes.VERTICAL_BUTTONS:
            groupClass += ' vertical labeled small icon buttons';
            break;
        case DisplayTypes.HORIZONTAL_BUTTONS:
            groupClass += ' icon basic buttons';
    }
    if (inverted) {
        groupClass += ' inverted';
    }
    var defaultTitle = window.document.title;
    var defaultCommunities = supportedCommunities.map(function (communityType) {
        var communityDefinition = {
            type: communityType,
            count: 0,
            article_id: '-1',
            share_type_id: '-1',
            title: defaultTitle,
            name: messages[communityType]['name'],
            description: messages[communityType]['description'],
            facebook_id: undefined,
            via: undefined
        };
        if (communityType === 'twitter') {
            communityDefinition.via = messages['twitter']['via'];
        }
        if (communityType === 'facebook') {
            communityDefinition.facebook_id = messages['facebook']['facebook_id'];
        }
        return communityDefinition;
    });
    var mappedCommunities = map(communities || defaultCommunities, function (d) { return d.type; });
    return (createElement("div", { className: groupClass }, supportedCommunities.map(function (communityType) {
        var community = mappedCommunities.get(communityType);
        if (community === undefined) {
            return;
        }
        var count = community.count;
        var shareUrl = url;
        if (communityType === 'share') {
            if (community.url === undefined) {
                shareUrl = "mailto:?subject=" + window.document.title + "&body=" + url;
            }
            else {
                shareUrl = community.url;
            }
        }
        if (communityType === 'facebook') {
            count += additionalFacebookShares;
        }
        var onClickHandler = clickHandler.bind(null, community);
        return (createElement(ShareItem, __assign({ key: communityType }, community, { displayType: displayType, inverted: inverted, onClick: onClickHandler, className: itemClassName, shareUrl: shareActionFactory[communityType](__assign({ hashtags: hashtags }, community, { url: shareUrl })), count: count })));
    })));
}

var API_SUBDOMAIN = 'm';
function notifyNewsnetShareCounter(articleId, shareTypeId) {
    fetch("//" + API_SUBDOMAIN + "." + parseHostname().publicationDomain + "/api/communities/" + articleId + "/counts/" + shareTypeId, {
        method: 'POST'
    })
        .then(function (res) {
        if (!res.ok)
            throw new Error('There is a problem with the' + ' backend.');
    })
        .catch(function (error) {
        console.log('[Default Share Button Handler]: Could not notify Newsnet' +
            ' share counter.', error);
    });
}
function notifyGoogleAnalytics(articleId, url, socialNetwork) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        article_id: articleId,
        event: 'Social',
        event_action: 'share',
        event_label: url,
        socialNetwork: socialNetworkNameReplacement[socialNetwork]
    });
}
function defaultClickHandler(articleId, community) {
    notifyNewsnetShareCounter(articleId, community.share_type_id);
    notifyGoogleAnalytics(articleId, getDefaultUrl(), community.type);
}

var requestStatus;
(function (requestStatus) {
    requestStatus["LOADING"] = "loading";
    requestStatus["ERROR"] = "error";
    requestStatus["READY"] = "ready";
})(requestStatus || (requestStatus = {}));
var API_SUBDOMAIN$1 = 'm';
var PolymorphicShareButtons = (function (_super) {
    __extends(PolymorphicShareButtons, _super);
    function PolymorphicShareButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loadingState: requestStatus.LOADING,
            communities: []
        };
        return _this;
    }
    PolymorphicShareButtons.prototype.render = function () {
        if (this.state.loadingState === requestStatus.LOADING) {
            return null;
        }
        if (this.state.loadingState === requestStatus.ERROR) {
            return (React__default.createElement(ShareButtons, __assign({}, this.props, { clickHandler: this.props.clickHandler.bind(null, this.props.articleId) })));
        }
        return (React__default.createElement(ShareButtons, __assign({}, this.props, { communities: this.state.communities, clickHandler: this.props.clickHandler.bind(null, this.props.articleId) })));
    };
    PolymorphicShareButtons.prototype.componentDidMount = function () {
        var _this = this;
        return fetch("https://" + API_SUBDOMAIN$1 + "." + parseHostname().publicationDomain + "/api/articles/" + this.props.articleId + "/external_services")
            .then(function (res) {
            return res.json().then(function (data) {
                _this.setState({
                    communities: data.communities,
                    loadingState: requestStatus.READY
                });
            });
        })
            .catch(function () {
            console.group('@ta-interaktiv/react-share-buttons');
            console.warn('Error while loading article data. Default values' + ' will be used.');
            console.groupEnd();
            _this.setState({
                loadingState: requestStatus.ERROR
            });
        });
    };
    PolymorphicShareButtons.defaultProps = {
        clickHandler: defaultClickHandler,
        locale: 'de'
    };
    return PolymorphicShareButtons;
}(Component));

export default PolymorphicShareButtons;
export { DisplayTypes, ShareButtons as PureShareButtons, PolymorphicShareButtons as ShareButtons, defaultClickHandler, DisplayTypes as displayTypes, supportedCommunities };
//# sourceMappingURL=index.js.map
